import ViewPhotos from './ViewPhotos'
export default ViewPhotos